//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SmartImage from '~/components/SmartImage';
import TaskModel from '~/model/TaskModel';

export default {
  name: 'TaskStatus',
  components: { SmartImage },
  props: {
    order: {
      type: Object,
      required: true,
    },
    dataProtectionMode: {
      type: String,
      default: '',
    },
    timer: { type: Number, default: 0 },
  },
  computed: {
    taskModel() {
      return new TaskModel(this.order.task);
    },
    workerFullName() {
      return `${this.order.worker.firstName} ${this.order.worker.lastName}`;
    },
    workerProfilePhoto() {
      return this.order.worker.profilePhoto?.resolutionMax;
    },
    taskTag() {
      const taskTag = this.taskModel.getTaskTag(this.order);
      return taskTag;
    },
    linkToSupportPhoneNumber() {
      return `tel:${this.order.task.supportNumber}`;
    },
  },
  methods: {
    getTimerText() {
      const model = new TaskModel(this.order.task);
      const timerText = model.getFormattedTimerText(null, this.order);
      // console.log(timerText, this.order, this.order.task);
      return timerText;
    },
    // async call() {
    //   // extracted to a method so that bi event would pass
    //   await this.$analytics.trackEvent(events.PRESS_CALL_TASK, {
    //     taskId: this.order.taskId,
    //   });
    //   const newWnd = window.open(
    //     'tel:' + this.order.task.supportNumber,
    //     '_self'
    //   );
    //   newWnd.opener = null;
    // },
    getAction() {
      const model = new TaskModel(this.order.task);
      const taskTag = model.getTaskTag(this.order);
      if (taskTag.text === 'tasks.statuses.reassignable') {
        return {
          text: 'tasks.statuses.reassignable',
          action: 'reassign',
        };
      } else if (taskTag.text === 'tasks.statuses.paymentFailed') {
        return {
          text: 'tasks.statuses.paymentFailed',
          action: 'pay',
        };
      } else if (taskTag.text === 'tasks.statuses.needsReview') {
        return {
          text: 'tasks.statuses.needsReview',
          action: 'review',
        };
      }
    },
  },
};
